import type { SentryTags } from '../types';

import { setTags } from '@sentry/nuxt';
import { INIT_STEPS } from '../config';
import { createSentryStateMachine } from './sentryStateMachine';

/**
 * Update Sentry tags after initialization (non-blocking)
 * Useful for updating tags when user state changes (e.g., login, logout)
 */
export function updateSentryTags(tags: SentryTags) {
	if (!import.meta.client) return;
	if (createSentryStateMachine()?.CURRENT() !== INIT_STEPS.INITIALIZED) return;

	setTags(tags);
}
